/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  return (
    <>
      <AsideMenuItem to='/performance' biIcon='bi-bar-chart-line' title='Performance' />

      <AsideMenuItem to='/setup/overview' biIcon='bi-grid-1x2' title='Setups Overview' />

      <AsideMenuItem to='/setup/add-setup' biIcon='bi-plus-circle' title='Create A Setup' />

      <AsideMenuItem to='/ai-coach' biIcon='bi-stars' title='AI Coach' />

      <AsideMenuItem to='/referral' biIcon='bi-share' title='Social' />
    </>
  )
}
